import { render, staticRenderFns } from "./gImg.vue?vue&type=template&id=7fb2c6c5&scoped=true"
import script from "./gImg.vue?vue&type=script&lang=js"
export * from "./gImg.vue?vue&type=script&lang=js"
import style0 from "./gImg.vue?vue&type=style&index=0&id=7fb2c6c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb2c6c5",
  null
  
)

export default component.exports